
export default function () {
  return navigator.userAgent.toLowerCase() === 'twspacespdfexporter';
}
